
export default {
    name: 'LeeMenuTree',
    inheritAttrs: false,
    data() {
        return {
        }
    },
    watch: {
    },
    mounted() {

    },
    methods: {
    },
    computed: {

    },
    props: {
    }
};
